import { createSlice } from "@reduxjs/toolkit";

import { slotsAPI } from "../../../api/master";
import { sliceHandler } from "../utils";

const getSlots = createSlice(
    sliceHandler({
        name: 'getSlots',
        action: 'getSlotsSlice',
        success: 'getSlotsSliceSuccess',
        failure: 'getSlotsSliceFailure',
        reset: 'getSlotsSliceReset'
    })
);

const getSlotsAction: any = getSlots.actions;
const getSlotsHandler = () => async (dispatch: any) => {
    try {
        dispatch(getSlotsAction.getSlotsSlice());
        const response: any = await slotsAPI();
        dispatch(getSlotsAction.getSlotsSliceSuccess(response));
    } catch (e: any) {
        dispatch(getSlotsAction.getSlotsSliceFailure(e?.response?.data));
    }
};

export {
    getSlotsAction,
    getSlotsHandler,
}
export default getSlots.reducer;